'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

AppVersionService=class AppVersionService extends BaseService{
static get $inject(){
return[];
}

constructor(){
super();
}

getRevision(){
return'6d7eac60ef3b032f158d460b3da4f0bfd32a60aa';
}};


module.exports=AppVersionService;
//# sourceMappingURL=appVersionService.js.map
